<div class="reporting-chart">
    <div class="monitoring-data-calendar-dateTime">
        <div class="monitoring-data-calendar">
            <mat-form-field appearance="outline">
            <mat-label>Rango de Fechas</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input matStartDate #dateRangeStart>
                <input matEndDate #dateRangeEnd (dateChange)="dateRangeChange(dateRangeStart, dateRangeEnd)">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
        </div>
    </div>

    <div class="chart">
        <app-mask [mask]="mask" [color]="'#f3f3f3'"></app-mask>
        <canvas #chartCanvas id="reportingChart"></canvas>
    </div>
    
</div>